<template>
  <div class="home">
    <Carousel ref="carousel" height="9rem" width="100%" :imgs="imgs"></Carousel>
    <section class="pile">
      <div class="left">
        <img @mouseenter="fdPile = true" @mouseleave="fdPile = false" :class="{fd: fdPile}" @click="() => $router.push({name: 'productPile1'})" :src="require(is1920 ? '../assets/pile1.png' : '../assets/pile28801.png')"/>
        <div class="desc">
          <p>简约 时尚 智能</p>
          <p>全新上市</p>
        </div>
      </div>
      <div class="right" >
        <div style="cursor: pointer;" class="up" @click="() => $router.push({name: 'serviceSupport'})">
          <img @mouseenter="fdPile1 = true" @mouseleave="fdPile1 = false" :class="{fd: fdPile1}" :src="require(is1920 ? '../assets/pile2.png' : '../assets/pile28802.png')"/>
          <div class="desc">
            <p>服务支持</p>
            <p>极致的体验</p>
          </div>
        </div>
        <div style="cursor: pointer;" class="down" @click="() => $router.push({name: 'guide'})">
          <img @mouseenter="fdPile2 = true" @mouseleave="fdPile2 = false" :class="{fd: fdPile2}" :src="require(is1920 ? '../assets/pile3.png' : '../assets/pile28803.png')"/>
          <div class="desc">
            <p>充电操作指引</p>
            <p>操作简便 安全高效</p>
          </div>
        </div>
      </div>
    </section>
    <section class="gw">
      <h2>探索国恒充电</h2>
      <h4>专人定期巡检，无需担心充电盒被盗或被破坏，更安全</h4>
      <div class="pics">
        <div>
          <img :src="require(is1920 ? '../assets/gw1.png' : '../assets/gw28801.png')"/>
          <p>享受 舒适</p>
        </div>
        <div>
          <img :src="require(is1920 ? '../assets/gw2.png' : '../assets/gw28802.png')"/>
          <p>挑战 突破</p>
        </div>
        <div>
          <img :src="require(is1920 ? '../assets/gw3.png' : '../assets/gw28803.png')"/>
          <p>社区 节能</p>
        </div>
        <div>
          <img :src="require(is1920 ? '../assets/gw4.png' : '../assets/gw28804.png')"/>
          <p>热情 绽放</p>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Carousel from '@/components/Carousel'
export default {
  name: 'home',
  inject: ['is1920'],
  components: {
    Carousel
  },
  data () {
    return {
      fdPile: false,
      fdPile1: false,
      fdPile2: false,
      imgs: [{ url: require('../assets/home1.gif'), desc: ['智慧充电', '智慧充电云平台，为生活注入科技'] },
        { url: require('../assets/home2.png'), desc: ['智慧充电', '智能服务，畅享出行'] },
        { url: require('../assets/home3.gif'), desc: ['智慧交流充电桩', '精工打造，至高品质'] }]
    }
  }
}
</script>
<style lang="less">
.home{
  overflow-x: hidden;
  img{
    width: 100%;
    height: 100%;
  }
  .desc{
    &.home0{
      padding-top: 1.68rem;
      padding-left: 4.46rem;
      &>div{
        text-align: left;
        &:nth-child(1){
          color: white;
          font-size: .60rem;
          line-height: .84rem;
        }
        &:nth-child(2){
          font-size: .28rem;
          line-height: .40rem;
          color: #d4d1d1;
        }
      }
    }
    &.home1{
      padding-top: 1.68rem;
      padding-left: 8.4rem;
      &>div{
        text-align: left;
        &:nth-child(1){
          color: #333;
          font-size: .60rem;
          line-height: .84rem;
          margin-bottom: -0.03rem;
        }
        &:nth-child(2){
          font-size: .28rem;
          line-height: .40rem;
          color: #666;
        }
      }
    }
    &.home2{
      padding-top: 3.3rem;
      padding-left: 4.07rem;
      &>div{
        text-align: left;
        &:nth-child(1){
          color: #333;
          font-size: .60rem;
          line-height: .8rem;
          margin-bottom: -0.03rem;
        }
        &:nth-child(2){
          font-size: .28rem;
          line-height: .40rem;
          color: #666;
        }
      }
    }
  }
  .pile{
    width: 12.2rem;
    height: 6.6rem;
    margin: 1rem auto;
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    .fd{
      cursor: pointer;
      transition: all .3s ease-in-out;
      transform: scale(1.03);
    }
    .left{
      position: relative;
      flex: 0 0 5.95rem;
      width: 5.95rem;
      height: 6.6rem;
      overflow: hidden;
      .desc{
        width: 100%;
        position: absolute;
        top: .38rem;
        text-align: center;
        p{
          &:first-child{
            font-size: .36rem;
            line-height: .50rem;
            color: #FFF;
            margin-bottom: .10rem;
          }
          &:last-child{
            font-size: .28rem;
            line-height: .40rem;
            color: #13E4E8;
          }
        }
      }
    }
    .right{
      flex: 0 0 5.86rem;
      display: flex;
      flex-direction: column;
      >div{
        position: relative;
        overflow: hidden;
        height: 3.2rem;
        img{
          width: 5.86rem;
          height: 3.2rem;
        }
        .desc{
          width: 100%;
          position: absolute;
          top: .37rem;
          text-align: center;
        }
        &.up{
          margin-bottom: .2rem;
        }
        &.up .desc{
          p{
            &:nth-child(1){
              font-size: .30rem;
              line-height: .40rem;
              color: #081530;
            }
            &:nth-child(2){
              font-size: .18rem;
              line-height: .24rem;
              color: #6D7278;
            }
          }
        }
        &.down .desc{
          p{
            &:nth-child(1){
              font-size: .30rem;
              line-height: .40rem;
              color: #fff;;
            }
            &:nth-child(2){
              font-size: .18rem;
              line-height: .24rem;
              color: #fff;
              opacity: .6;
            }
          }
        }
      }
    }
  }
  .gw{
    width: 12.2rem;
    margin: 0 auto 1rem;
    h2{
      margin: 0;
      font-size: .50rem;
      line-height: .70rem;
      color: #000;
    }
    h4{
      font-size: .26rem;
      line-height: .37rem;
      color: #6D7278;
      margin: .1rem 0 .6rem;
    }
    .pics{
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      div{
        flex:0 0 5.9rem;
        height: 4.3rem;
        img{
          width: 5.9rem;
          height: 3.5rem;
        }
        p{
          font-size: .28rem;
          line-height: .40rem;
          color: #081530;
          margin: -0.1rem 0 0 0;
        }
      }
    }
  }
}
</style>
